// Use $ instead of $ without replacing global $
(function ($) {

  $('.col-two-details .download-drop > a').on('click',function (e) {
    e.stopPropagation();
    e.preventDefault();
    $('.col-two-details .download-sub').toggleClass('active');
    $(".col-two-details .download-sub").stop(true, true).slideToggle();
  });

  $(document).on("click",function () {
    $('.col-two-details .download-sub').slideUp();
  });

  if($('.col-two-details .download-drop').length > 0) {
    $('.col-two-details').addClass('we-overflow');
  }

})(jQuery);